import {useState, useRef} from 'react';

import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';
import {RelativeTimestamp} from 'shells/timestamp/relative-timestamp';
import {Body} from 'shells/typography/body';

import type {CreatorUserFragment} from 'nutshell-graphql-types';

import {CreateInfoPopover} from './create-info-popover';

interface Props {
    creatorUser: CreatorUserFragment | null;
    createdTime: number | null;
}

export function CreateInfo(props: Props) {
    const [isUserPopoverOpen, setIsUserPopoverOpen] = useState<boolean>(false);
    const userLinkRef = useRef<HTMLDivElement | null>(null);

    if (!props.creatorUser || !props.createdTime) {
        return null;
    }

    return (
        <Stack isHorizontal={true} spacing={4} alignItems='center'>
            <Body size='small' color='light' nowrap={true}>
                Created by
            </Body>
            <Link variant='secondary' onClick={() => setIsUserPopoverOpen(true)}>
                <div ref={(ref) => (userLinkRef.current = ref)}>
                    <Body size='small' color='light' underline={true} nowrap={true}>
                        {props.creatorUser.name},
                    </Body>
                </div>
            </Link>
            <RelativeTimestamp
                datetime={props.createdTime}
                format='fromNow'
                className='light-text'
            />
            {isUserPopoverOpen && userLinkRef.current && (
                <CreateInfoPopover
                    creatorUser={props.creatorUser}
                    onClose={() => setIsUserPopoverOpen(false)}
                    anchor={userLinkRef.current}
                />
            )}
        </Stack>
    );
}
